module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-history-container"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": "//p1.meituan.net/codeman/e65a1cf67d9aa36a496eb840309a21e515921.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("美团旅行商家版")]), _vm._v("\n        用手机随时随地管理商铺\n        "), _c('p', {
    staticClass: "info"
  }, [_vm._v(" 如二维码不可用，请到应用商店搜索「美团旅行商家」")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box"
  }, [_c('h2', [_vm._v("手机验证方法:")]), _vm._v(" "), _c('p', [_vm._v("1.扫描二维码下载商家app")]), _vm._v(" "), _c('p', [_vm._v("2.登录商家账号及密码,进入验证页面")]), _vm._v(" "), _c('p', [_vm._v("3.在页面输入门票密码或直接扫描二维码进行验证")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50898914","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ticket/verify/phone/pages/appVerify.vue
// module id = 600
// module chunks = 0